import { Box, Skeleton, Stack } from '@mui/material'
import { MAX_WIDGET_SIZE } from '@shared/constants'
import { FlexCardDisplaySkeleton } from 'components-ui/src/flex_card_display/flex_card_display_skeleton'
import { InvoiceCardSkeleton } from 'components-ui/src/purchase_summary/invoice_card/invoice_card_skeleton'
import { PurchaseReceiptSkeleton } from 'components-ui/src/purchase_summary/purchase_receipt/purchase_receipt_skeleton'

export const PurchaseSummarySkeleton = () => {
  return (
    <Stack spacing={3} sx={{ maxWidth: MAX_WIDGET_SIZE, pb: '130px', margin: '0 auto' }}>
      <Skeleton variant="text" width={500} sx={{ mt: 3 }} />
      <Stack spacing={3}>
        <InvoiceCardSkeleton />
      </Stack>
      <Stack direction="row" spacing={1}>
        <Stack spacing={3} sx={{ flex: 1 }}>
          <FlexCardDisplaySkeleton />
          <FlexCardDisplaySkeleton />
        </Stack>
        <Box sx={{ flex: 1 }}>
          <PurchaseReceiptSkeleton />
        </Box>
      </Stack>
    </Stack>
  )
}
